import { api } from './api';

// Teams within organization
export const createTeam = async (orgId, data) => {
  const response = await api.post(`/organizations/${orgId}/teams`, data);
  return response.data;
};

export const getOrganizationTeams = async (orgId) => {
  const response = await api.get(`/organizations/${orgId}/teams`);
  return response.data;
};

// Team CRUD
export const getTeam = async (teamId) => {
  const response = await api.get(`/teams/${teamId}`);
  return response.data;
};

export const updateTeam = async (teamId, data) => {
  const response = await api.put(`/teams/${teamId}`, data);
  return response.data;
};

export const deleteTeam = async (teamId) => {
  const response = await api.delete(`/teams/${teamId}`);
  return response.data;
};

// Team Members
export const getTeamMembers = async (teamId) => {
  const response = await api.get(`/teams/${teamId}/members`);
  return response.data;
};

export const addTeamMember = async (teamId, data) => {
  const response = await api.post(`/teams/${teamId}/members`, data);
  return response.data;
};

export const updateTeamMember = async (teamId, userId, data) => {
  const response = await api.put(`/teams/${teamId}/members/${userId}`, data);
  return response.data;
};

export const removeTeamMember = async (teamId, userId) => {
  const response = await api.delete(`/teams/${teamId}/members/${userId}`);
  return response.data;
};

export const leaveTeam = async (teamId) => {
  const response = await api.post(`/teams/${teamId}/leave`);
  return response.data;
};

// Team Invites
export const createTeamInvite = async (teamId, data = {}) => {
  const response = await api.post(`/teams/${teamId}/invites`, data);
  return response.data;
};

export const getTeamInvites = async (teamId) => {
  const response = await api.get(`/teams/${teamId}/invites`);
  return response.data;
};

export const revokeTeamInvite = async (teamId, inviteId) => {
  const response = await api.delete(`/teams/${teamId}/invites/${inviteId}`);
  return response.data;
};

// Public invite endpoints
export const getTeamInviteDetails = async (token) => {
  const response = await api.get(`/teams/invite/${token}`);
  return response.data;
};

export const acceptTeamInvite = async (token) => {
  const response = await api.post(`/teams/join/${token}`);
  return response.data;
};

// Team Sessions
export const getTeamSessions = async (teamId) => {
  const response = await api.get(`/teams/${teamId}/sessions`);
  return response.data;
};

// Helper to generate invite link
export const generateTeamInviteLink = (token) => {
  const baseUrl = window.location.origin;
  return `${baseUrl}/invite/team/${token}`;
};

const teamsApi = {
  createTeam,
  getOrganizationTeams,
  getTeam,
  updateTeam,
  deleteTeam,
  getTeamMembers,
  addTeamMember,
  updateTeamMember,
  removeTeamMember,
  leaveTeam,
  createTeamInvite,
  getTeamInvites,
  revokeTeamInvite,
  getTeamInviteDetails,
  acceptTeamInvite,
  getTeamSessions,
  generateTeamInviteLink,
};

export default teamsApi;
